import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SettingsService } from 'src/app/services/settings.service';

@Injectable({
  providedIn: 'root'
})
export class ToolbarService {
  moduleNamePrev = '';
  
  constructor(
    private http: HttpClient,
    private settings: SettingsService
  ) { }

  setModuleNamePrev(noduleNameCurrent: string){
    this.moduleNamePrev = noduleNameCurrent;
  }

  getModuleNamePrev(): string{
    return this.moduleNamePrev;
  }

  //Servicio para recuperar la cantidad de notificaciones pendientes de lectura
  contarNotificacion() {
    return this.http.get(this.settings.URL_BASE + 'notificacion/contar/nuevas');
  }

  //Servicio para obtener el listado de notificaciones que recibe el usuario
  obtenerNotificaciones(filtro: any) {
    return this.http.post(`${this.settings.URL_BASE}notificacion/listar`, filtro)
  }
}
